export const YCP_FORM_CREATE_ACCOUNT = 'YCP_FORM_CREATE_ACCOUNT';
export const YCP_CABINET_NAVIGATION = 'YCP_CABINET_NAVIGATION';
export const YCP_SETTINGS_ADD_LOGO = 'YCP_SETTINGS_ADD_LOGO';
export const YCP_SETTINGS_ADD_STORE_INFO = 'YCP_SETTINGS_ADD_STORE_INFO';
export const YCP_SETTINGS_SETUP_MODULE = 'YCP_SETTINGS_SETUP_MODULE';
export const YCP_SETTINGS_CHECK_API_CONNECTION = 'YCP_SETTINGS_CHECK_API_CONNECTION';
export const YCP_SETTINGS_CHECK_BITRIX_CONNECTION = 'YCP_SETTINGS_CHECK_BITRIX_CONNECTION';
export const YCP_SETTINGS_CHECK_FEED = 'YCP_SETTINGS_CHECK_FEED';
export const YCP_SETTINGS_IMPORT_WAREHOUSE = 'YCP_SETTINGS_IMPORT_WAREHOUSE';
export const YCP_SETTINGS_API_CONNECT_DELIVERY = 'YCP_SETTINGS_API_CONNECT_DELIVERY';
export const YCP_SETTINGS_CONNECT_DELIVERY_INTEGRATION = 'YCP_SETTINGS_CONNECT_DELIVERY_INTEGRATION';
export const YCP_SETTINGS_CONNECT_PAYMENT_SERVICE = 'YCP_SETTINGS_CONNECT_PAYMENT_SERVICE';
export const YCP_SETTINGS_CONNECT_ONLINE_KASSA = 'YCP_SETTINGS_CONNECT_ONLINE_KASSA';
export const YCP_SETTINGS_CONNECT_YA_METRIKA = 'YCP_SETTINGS_CONNECT_YA_METRIKA';
export const YCP_SETTINGS_CONNECT_BUY_BUTTON_CLICK = 'YCP_SETTINGS_CONNECT_BUY_BUTTON_CLICK';
export const YCP_SETTINGS_CONNECT_BUY_BUTTON_SEND_FORM = 'YCP_SETTINGS_CONNECT_BUY_BUTTON_SEND_FORM';
export const YCP_CHECKOUT_PUBLISH = 'YCP_CHECKOUT_PUBLISH';
